import { FORMAT_DATE, FORMAT_DATE_TIME, FORMAT_DATE_FULL, FORMAT_TIME_DATE_FULL } from "../configure/systemConfig";
import { isNullOrEmpty } from "./util";
import moment from "moment";

function incremented(index) {
    index++;
    return index;
}

function isdefined(value) {
    return value !== undefined;
}

function isnotnull(value) {
    return value !== undefined && value.length > 0;
}

function isnotnullorempty(value) {
    return isNullOrEmpty(value);
}

function moneyformat(value) {
    return value?.toLocaleString("en-US");
}

function dateformat(value) {
    return value && moment(value).format(FORMAT_DATE);
}

function dateformatfull(value) {
    return value && moment(value).format(FORMAT_DATE_FULL);
}

function datetimeformat(value) {
    return value && moment(value).format(FORMAT_TIME_DATE_FULL);
}

function datetimeformatshort(value) {
    return value && moment(value).format(FORMAT_DATE_TIME);
}

function ifequal(arg1, arg2, options) {
    if (typeof(arg1) == "number")
        return arg1 == arg2 ? options.fn(this) : options.inverse(this);
    else
        return (arg1.toUpperCase() == arg2.toUpperCase()) ? options.fn(this) : options.inverse(this);
}

function ifnotequal(arg1, arg2, options) {
    if (typeof(arg1) == "number")
        return arg1 !== arg2 ? options.fn(this) : options.inverse(this);
    else
        return (arg1.toUpperCase() !== arg2.toUpperCase()) ? options.fn(this) : options.inverse(this);
}

function ifLengthEqual(list, arg2, options) {
    return (list.length == arg2) ? options.fn(this) : options.inverse(this);
}

function ifLengthLessThan(list, arg2, options) {
    return (list.length < arg2 && list.length > 0) ? options.fn(this) : options.inverse(this);
}

function ifLengthGreaterThan(list, arg2, options) {
    return (list.length > arg2) ? options.fn(this) : options.inverse(this);
}

function ifCondition(arg1, operator, arg2, options) {
    switch (operator) {
        case '==':
            return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (arg1 === arg2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
        case '!==':
            return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (arg1 < arg2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (arg1 <= arg2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (arg1 > arg2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (arg1 >= arg2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (arg1 && arg2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (arg1 || arg2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
}

export default {
    incremented,
    isdefined,
    isnotnull,
    isnotnullorempty,
    moneyformat,
    dateformat,
    dateformatfull,
    datetimeformat,
    datetimeformatshort,
    ifequal,
    ifnotequal,
    ifLengthEqual,
    ifLengthLessThan,
    ifLengthGreaterThan,
    ifCondition,
}